class Accordion {
  constructor(containerId) {
    this.container = document.getElementById(containerId);
    if (!this.container) return;
    this.headers = this.container.querySelectorAll('.acc-header');
    this.headers.forEach(header => {
      header.addEventListener('click', () => this.toggle(header));
    });
  }
  toggle(header) {
    const panelId = header.getAttribute('data-panel');
    const panel = document.getElementById(panelId);
    const isActive = header.classList.contains('active');
    this.headers.forEach(h => {
      h.classList.remove('active');
      const p = document.getElementById(h.getAttribute('data-panel'));
      if (p) p.classList.remove('active');
    });
    if (!isActive) {
      header.classList.add('active');
      if (panel) panel.classList.add('active');
    }
  }
}

// 单位切换逻辑
function initSizeToggle() {
  document.querySelectorAll('.sizeCentimetersCheckbox input, .sizeInchesCheckbox input').forEach(radio => {
    radio.addEventListener('change', function () {
      const container = this.closest('size-toggle');
      if (!container) return;
      const isCm = container.querySelector('.sizeCentimetersCheckbox input').checked;
      container.querySelectorAll('.size-value').forEach(td => {
        td.textContent = isCm
          ? (td.dataset.centimeters || td.dataset.inches)
          : td.dataset.inches;
      });
    });
  });
}

// 仅在 Size Guide 页面初始化
if (document.getElementById('myAccordion')) {
  document.addEventListener('DOMContentLoaded', function () {
    new Accordion('myAccordion');
    initSizeToggle();
  });
}